/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Enable_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to enable SCIM provisioning" |
*
* @param {Scim_Enable_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_enable_error = /** @type {((inputs?: Scim_Enable_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Enable_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Aktivieren der SCIM-Bereitstellung")
	return /** @type {LocalizedString} */ ("Failed to enable SCIM provisioning")
});